<payee-popup
  [title]="dialogData?.transition_label"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <div class="dialog-content">
    <form [formGroup]="form">
      <form [formGroup]="case_id">
        <payee-form-field width="wide">
          <span payee-label>Fizetési meghagyás ügyszám</span>
          <div class="case-id-mask">
            <input
              #partA
              class="case-id-part"
              placeholder="00000"
              formControlName="partA"
            />
            <span class="case-id-separator">/Ü/</span>
            <input
              #partB
              class="case-id-part"
              placeholder="00000"
              formControlName="partB"
            />
            <span class="case-id-separator">/</span>
            <input
              #partC
              class="case-id-part"
              placeholder="0000"
              formControlName="partC"
            />
          </div>
          @if (case_id.invalid && case_id.dirty) {
            <span payee-error>Az ügyszám formátuma nem megfelelő. Elvárt formátum: #####/Ü/#####/YYYY (pl. 41012/Ü/70224/2026)</span>
          }
        </payee-form-field>
      </form>

      <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

      <div class="subtitle">Fájlok feltöltése</div>

      <payee-form-field width="wide">
        <payee-dropzone
          width="wide"
          [title]="dropzoneTitle"
          (dropped)="onDrop($event)"
        ></payee-dropzone>
        @if (form.get("files")?.invalid && form.get("files")?.touched) {
          <span payee-error>Kérünk, tölts fel legalább egy fájlt.</span>
        }
      </payee-form-field>

      <div class="files-list">
        @for (file of files.value; track $index; let fileIndex = $index) {
          <div class="file-item flex vcenter">
            <div class="file-status">
              <payee-icon name="checkmark-darker-green-circle"></payee-icon>
            </div>
            <div class="file-name">{{ file.name }}</div>
            <button
              payee-icon-button
              color="white"
              class="file-delete-button"
              (click)="removeFile(fileIndex)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </div>
    </form>
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="wide"
      [disabled]="loading"
      [loading]="loading"
      (click)="onSubmit()"
    >
      Rögzítés
    </button>
  </ng-template>
</payee-popup>
